import { render, staticRenderFns } from "./edit-service-fee-dialog.vue?vue&type=template&id=dba83c68&scoped=true"
import script from "./edit-service-fee-dialog.vue?vue&type=script&lang=js"
export * from "./edit-service-fee-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-service-fee-dialog.vue?vue&type=style&index=0&id=dba83c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba83c68",
  null
  
)

export default component.exports